import { useLayoutContext } from '@/contexts';
import { AnimatePresence, motion } from 'motion/react';
import { useEffect, useRef, useState } from 'react';
import styles from './styles.module.css';

export const WorkflowFooter = ({
	secondaryContent,
	children,
	noPad,
}: {
	secondaryContent?: React.ReactNode;
	children: React.ReactNode;
	noPad?: boolean;
}) => {
	const { isApp } = useLayoutContext();
	const [offset, setOffset] = useState(75);
	const mainContentRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (mainContentRef.current) {
			// Gets the height of the main content bar
			if (mainContentRef.current.offsetHeight !== offset) {
				setOffset(mainContentRef.current.offsetHeight);
			}
		}
	}, [offset, secondaryContent, isApp]);

	return (
		<AnimatePresence>
			{secondaryContent && (
				<motion.div
					initial={{ opacity: 0, y: offset }}
					key="secondary-content"
					animate={{
						opacity: 1,
						y: 0,
						transition: { duration: 0.2, delay: 0.2, ease: 'easeInOut' },
					}}
					exit={{
						opacity: 0,
						y: offset,
						transition: { duration: 0.2, ease: 'easeInOut' },
					}}
					style={{ bottom: !isApp ? 75 : 105 }}
					className={styles.secondaryContent}
				>
					{secondaryContent}
				</motion.div>
			)}
			<div
				ref={mainContentRef}
				style={{ paddingBottom: isApp ? (noPad ? '30px' : 55) : noPad ? 0 : 16 }}
				className={noPad ? styles.workflowMobileFooterNoPad : styles.workflowMobileFooter}
			>
				{children}
			</div>
		</AnimatePresence>
	);
};
